'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _vue2.default.component('mdi-snowflake-icon', {
  template: '<svg :class="[\'mdi-icon\', className]" :width="width" :height="height" :viewBox="viewBox"><path  d="M 20.79,13.95L 18.46,14.57L 16.46,13.44L 16.46,10.56L 18.46,9.43L 20.79,10.05L 21.31,8.12L 19.54,7.65L 20,5.88L 18.07,5.36L 17.45,7.69L 15.45,8.82L 13,7.38L 13,5.12L 14.71,3.41L 13.29,2L 12,3.29L 10.71,2L 9.29,3.41L 11,5.12L 11,7.38L 8.5,8.82L 6.5,7.69L 5.92,5.36L 4,5.88L 4.47,7.65L 2.7,8.12L 3.22,10.05L 5.55,9.43L 7.55,10.56L 7.55,13.45L 5.55,14.58L 3.22,13.96L 2.7,15.89L 4.47,16.36L 4,18.12L 5.93,18.64L 6.55,16.31L 8.55,15.18L 11,16.62L 11,18.88L 9.29,20.59L 10.71,22L 12,20.71L 13.29,22L 14.7,20.59L 13,18.88L 13,16.62L 15.5,15.17L 17.5,16.3L 18.12,18.63L 20,18.12L 19.53,16.35L 21.3,15.88L 20.79,13.95 Z M 9.5,10.56L 12,9.11L 14.5,10.56L 14.5,13.44L 12,14.89L 9.5,13.44L 9.5,10.56 Z "/></svg>',
  props: {
    className: [Object, Array, String],
    width: {
      type: Number,
      'default': 24
    },
    height: {
      type: Number,
      'default': 24
    },
    viewBox: {
      type: String,
      'default': '0 0 24 24'
    }
  }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/mdi-vue/SnowflakeIcon.js
// module id = R+vp
// module chunks = 0